module.exports = __webpack_public_path__ + "static/media/barcode.f0cf7f08.svg";